import { IconFn, IconSvg } from "../createIcon";

export const LightBulbIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 39, height: 52 }} {...props}>
    <path
      d="M8.94438 5.37133L11.1744 8.70498C11.2419 8.65125 11.3098 8.5981 11.3784 8.54554C13.8153 6.67687 16.8006 5.66406 19.8715 5.66406L8.94438 5.37133Z"
      fill={color}
    />
    <path
      d="M19.8715 1.66406C15.9205 1.66406 12.0797 2.96712 8.94438 5.37133L19.8715 5.66406C22.9425 5.66406 25.9277 6.67686 28.3646 8.54554C30.8016 10.4142 32.5542 13.0344 33.351 16.0002C34.1478 18.966 33.9442 22.1118 32.7718 24.9501C31.5993 27.7885 29.5236 30.1609 26.8661 31.6999L26.8649 31.7005L28.8601 35.1432L28.8718 35.1607C32.2903 33.1807 34.9605 30.1286 36.4688 26.4772C37.9772 22.8255 38.2391 18.7782 37.214 14.9624C36.1889 11.1467 33.934 7.77554 30.7987 5.37133C27.6633 2.96712 23.8226 1.66406 19.8715 1.66406Z"
      fill={color}
    />
    <path
      d="M6.97128 24.9501C5.79886 22.1118 5.59526 18.966 6.39202 16.0002C7.16638 13.1179 8.8436 10.5619 11.1744 8.70498L8.94438 5.37133C5.80902 7.77554 3.5541 11.1467 2.529 14.9624C1.5039 18.7782 1.76585 22.8255 3.27426 26.4772C4.7825 30.1286 7.45272 33.1807 10.8713 35.1607C12.2883 35.9826 13.0853 37.2069 13.0853 38.3583V38.7668C13.0853 39.8713 13.9808 40.7668 15.0853 40.7668C16.1899 40.7668 17.0853 39.8713 17.0853 38.7668V38.3583C17.0853 35.3267 15.0781 32.9765 12.8781 31.7005L12.877 31.6999C10.2195 30.1609 8.14369 27.7885 6.97128 24.9501Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1787 25.2573C16.1089 24.9825 15.0188 25.627 14.744 26.6968C14.4692 27.7666 15.1136 28.8567 16.1835 29.1315C16.7402 29.2745 17.3042 29.3848 17.8726 29.462V38.7668C17.8726 39.8713 18.768 40.7668 19.8726 40.7668C20.9772 40.7668 21.8726 39.8713 21.8726 38.7668V29.462C22.441 29.3848 23.005 29.2745 23.5617 29.1315C23.9248 29.0383 24.239 28.851 24.4848 28.6026L22.2917 25.3241C21.499 25.5057 20.688 25.5972 19.8741 25.5966H19.871C18.9629 25.5973 18.0583 25.4833 17.1787 25.2573ZM19.8726 29.5966L19.871 29.5966L19.8726 27.5966L19.8741 29.5966L19.8726 29.5966Z"
      fill={color}
    />
    <path
      d="M25.0012 26.6968C24.7263 25.627 23.6363 24.9825 22.5664 25.2573C22.4751 25.2808 22.3835 25.303 22.2917 25.3241L24.4848 28.6026C24.9631 28.119 25.1827 27.4035 25.0012 26.6968Z"
      fill={color}
    />
    <path
      d="M26.6598 38.3583C26.6598 37.2061 27.4556 35.9825 28.8706 35.1613L28.8601 35.1432L26.6451 31.832C24.532 33.135 22.6598 35.429 22.6598 38.3583V38.7668C22.6598 39.8713 23.5552 40.7668 24.6598 40.7668C25.7644 40.7668 26.6598 39.8713 26.6598 38.7668V38.3583Z"
      fill={color}
    />
    <path
      d="M15.4585 41.1402C14.3733 40.9341 13.3265 41.6468 13.1205 42.7319C12.9144 43.8171 13.627 44.8639 14.7122 45.07C18.122 45.7175 21.6232 45.7175 25.0329 45.07C26.1181 44.8639 26.8308 43.8171 26.6247 42.7319C26.4186 41.6468 25.3719 40.9341 24.2867 41.1402C21.37 41.6941 18.3752 41.6941 15.4585 41.1402Z"
      fill={color}
    />
    <path
      d="M16.8893 46.1862C15.7908 46.0711 14.807 46.8685 14.692 47.967C14.577 49.0656 15.3743 50.0494 16.4728 50.1644C18.7332 50.4011 21.012 50.4011 23.2723 50.1644C24.3709 50.0494 25.1682 49.0656 25.0532 47.967C24.9382 46.8685 23.9544 46.0711 22.8558 46.1862C20.8724 46.3938 18.8727 46.3938 16.8893 46.1862Z"
      fill={color}
    />
    <path
      d="M26.8649 31.7005C26.7914 31.7432 26.7181 31.787 26.6451 31.832L28.8601 35.1432L26.8649 31.7005Z"
      fill={color}
    />
  </IconSvg>
);
